const debtor_group = {
	add_button: "Add Debtor",
	add_debtor_dialog: {
		description: "Add Debtor",
		form: {
			debtor_code: "Debtor Code",
		},
		title: "Add Debtor",
	},
	delete_dialog: {
		description: "Do you really want to unlink debtor <strong>{{name}}</strong>?",
		title: "Unlink Debtor",
	},
	status: {
		add_debtor: {
			success: "Debtor <strong>{{debtor_code}}</strong> successfully added to the debtor group.",
			unknown: "The chosen debtor cannot be added at the moment. Please try again later.",
		},
		delete_debtor: {
			not_empty: "Debtor group is not empty, please unlink all debtors first.",
			success: "Debtor successfully removed from the debtor group.",
			unknown: "The chosen debtor cannot be removed at the moment. Please try again later.",
		},
	},
	title: "Debtor Group",
};

export default debtor_group;
